export enum VideoType {
  HOSTED = 'hosted',
  EMBEDDED = 'embedded',
}